import { motion } from "framer-motion";

export default function MotionDiv({
  children,
  variants,
  className = "",
  ...props
}) {
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}